import React from 'react';
import SubjectForm from '../SubjectForm/SubjectForm';

const EditSubjectForm: React.FC = () => {
    return <SubjectForm mode="edit" />;
};

export default EditSubjectForm;
